'use client'

function applyMask(raw) {
  let digits = raw.replace(/\D/g, '')
  // Normalize leading 7 or 8 — we always prefix +7
  if (digits.startsWith('7') || digits.startsWith('8')) digits = digits.slice(1)
  digits = digits.slice(0, 10)

  if (!digits) return ''
  let r = '+7 (' + digits.slice(0, 3)
  if (digits.length > 3) r += ') ' + digits.slice(3, 6)
  if (digits.length > 6) r += '-' + digits.slice(6, 8)
  if (digits.length > 8) r += '-' + digits.slice(8, 10)
  return r
}

export default function PhoneInput({ value, onChange, className, ...props }) {
  const handleChange = (e) => {
    const masked = applyMask(e.target.value)
    onChange({ ...e, target: { ...e.target, value: masked } })
  }

  const handleKeyDown = (e) => {
    // Allow control keys
    if (
      e.key === 'Backspace' || e.key === 'Delete' ||
      e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' ||
      e.ctrlKey || e.metaKey ||
      e.key.startsWith('Arrow') || e.key === 'Home' || e.key === 'End'
    ) return
    // Block everything except digits
    if (!/^\d$/.test(e.key)) e.preventDefault()
  }

  return (
    <input
      type="tel"
      inputMode="numeric"
      placeholder="+7 (___) ___-__-__"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      className={className}
      {...props}
    />
  )
}
